import { createRouter, createWebHistory } from 'vue-router'

const Layout = () => import('@/views/Layout')
const Home = () => import('@/views/home')
const Attention = () => import('@/views/service')
const Describe = () => import('@/views/describe')
const LayoutInfo = () => import('@/views/info/Layout')
const Notification = () => import('@/views/info/notification')
const Notificationed = () => import('@/views/info/notificationed')
const Audit = () => import('@/views/info/audit')
const Audited = () => import('@/views/info/audited')
const PersonalInfo = () => import('@/views/info')

const Password = () => import('@/views/info/password')
const Email = () => import('@/views/info/email')
const Telephone = () => import('@/views/info/telephone')
const Verify = () => import('@/views/info/verify')
const IdNum = () => import('@/views/info/idNum')
const Binding = () => import('@/views/info/binding')
const Register = () => import('@/views/register')

const EkpInfo = () => import('@/views/ekp')
const EkpLayoutInfo = () => import('@/views/ekp/Layout')
const EkpNotification = () => import('@/views/ekp/notification')
const EkpNotificationed = () => import('@/views/ekp/notificationed')
const EkpAudit = () => import('@/views/ekp/audit')
const EkpAudited = () => import('@/views/ekp/audited')

const EkpPassword = () => import('@/views/ekp/password')
const EkpEmail = () => import('@/views/ekp/email')
const EkpTelephone = () => import('@/views/ekp/telephone')
const EkpVerify = () => import('@/views/ekp/verify')
const EkpIdNum = () => import('@/views/ekp/idNum')
const EkpBinding = () => import('@/views/ekp/binding')
const EkpList = () => import('@/views/ekp/list')
const EkpFlows = () => import('@/views/ekp/flows')
const routes = [
  // 一级路由布局容器
  {
    path: '/',
    component: Layout,
    children: [
      { name: 'home', path: '', component: Home },
      { name: 'attention', path: '/attention', component: Attention },
      { name: 'describe', path: '/describe/:id', component: Describe }
      // { path: '/', redirect: '/index' }
    ]
  },
  {
    path: '/info',
    component: LayoutInfo,
    children: [
      {
        name: 'info',
        path: '/info',
        component: PersonalInfo
      },
      {
        name: 'password',
        path: 'password',
        component: Password
      },
      {
        name: 'email',
        path: 'email',
        component: Email
      },
      {
        name: 'telephone',
        path: 'telephone',
        component: Telephone
      },
      {
        name: 'verify',
        path: 'verify',
        component: Verify
      },
      {
        name: 'idNum',
        path: 'idNum',
        component: IdNum
      },
      {
        name: 'binding',
        path: 'binding',
        component: Binding
      },
      {
        name: 'notification',
        path: 'notification',
        component: Notification
      },
      {
        name: 'audit',
        path: 'audit',
        component: Audit
      },
      {
        name: 'notificationed',
        path: 'notificationed',
        component: Notificationed
      },
      {
        name: 'audited',
        path: 'audited',
        component: Audited
      }
    ]
  },
  {
    path: '/ekp',
    component: EkpLayoutInfo,
    children: [
      {
        name: 'info',
        path: '/ekp',
        component: EkpInfo
      },
      {
        name: 'password',
        path: 'password',
        component: EkpPassword
      },
      {
        name: 'email',
        path: 'email',
        component: EkpEmail
      },
      {
        name: 'telephone',
        path: 'telephone',
        component: EkpTelephone
      },
      {
        name: 'verify',
        path: 'verify',
        component: EkpVerify
      },
      {
        name: 'idNum',
        path: 'idNum',
        component: EkpIdNum
      },
      {
        name: 'binding',
        path: 'binding',
        component: EkpBinding
      },
      {
        name: 'notification',
        path: 'notification',
        component: EkpNotification
      },
      {
        name: 'audit',
        path: 'audit',
        component: EkpAudit
      },
      {
        name: 'notificationed',
        path: 'notificationed',
        component: EkpNotificationed
      },
      {
        name: 'audited',
        path: 'audited',
        component: EkpAudited
      },
      {
        name: 'list',
        path: 'list',
        component: EkpList
      },
      {
        name: 'flows',
        path: 'flows',
        component: EkpFlows
      }
    ]
  },
  {
    name: 'register',
    path: '/register',
    component: Register
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior () {
    return { top: 0, left: 0 }
  }
})

export default router
